import React from 'react';

import { Table } from '@devexpress/dx-react-grid-material-ui';
import ScoringActionCell from './ScoringActionCell';
import EnabledStateCell from '../../components/RulesTable/EnabledStateCell';


import defaultClasses from '../../components/RulesTable/RulesTable.module.css';

function ScoringTableCellRenderer(cellProps) {
    let Component;
    switch (cellProps.column.name) {
        case 'action':
            Component = ScoringActionCell;
            break;
        case 'enabled':
            Component = EnabledStateCell;
            break;
        default:
            Component = Table.Cell;
    }
    return (
        <Component {...cellProps} className={defaultClasses.cell} />
    );
}

export default ScoringTableCellRenderer;
